import { removePropertyEmpty } from '@/utils/index'
import { LOGINv2, LoginService } from '../../loginConfig'

class AuthenticationServiceV2 extends LoginService {
  path = 'account'

  constructor() {
    super(LOGINv2)
  }

  async getPermission(params?: any) {
    const httpResponse = await this.httpClient.get(
      this.path + '/obterlistafuncoespermissoes',
      { params: removePropertyEmpty(params) }
    )
    return httpResponse
  }
}

export const authenticationServiceV2 = new AuthenticationServiceV2()
